"use client";

import React from "react";
import { Button } from "@wtc/ui";
import { ChevronLeft } from "lucide-react";
import type { RankedCandidate } from "@/lib/research/api-types";
import { CompanyCandidateCard } from "./CompanyCandidateCard";

interface CompanySelectionStepProps {
  candidates: RankedCandidate[];
  onSelectCompany: (candidate: RankedCandidate) => void;
  onBack: () => void;
  loading: boolean;
}

export function CompanySelectionStep({
  candidates,
  onSelectCompany,
  onBack,
  loading,
}: CompanySelectionStepProps) {
  return (
    <div className="space-y-4">
      <div className="text-sm text-gray-600 dark:text-gray-400">
        Select the company that best matches your search:
      </div>

      <div className="space-y-3 max-h-[600px] overflow-y-auto">
        {candidates.map((candidate, idx) => (
          <CompanyCandidateCard
            key={candidate.id}
            candidate={candidate}
            rank={idx + 1}
            onSelect={onSelectCompany}
            disabled={loading}
          />
        ))}
      </div>

      <div className="flex gap-2">
        <Button
          variant="outline"
          onClick={onBack}
          disabled={loading}
          className="flex-1"
        >
          <ChevronLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
      </div>
    </div>
  );
}
